const safeText = (value) => (typeof value === 'string' ? value : '');

export function buildListingRoute(listing = {}) {
  const fromAddress = safeText(listing.fromAddress);
  const fromCity = safeText(listing.fromCity);
  const fromCountry = safeText(listing.fromCountry);
  const toAddress = safeText(listing.toAddress);
  const toCity = safeText(listing.toCity);
  const toCountry = safeText(listing.toCountry);

  const distanceKm = listing.distanceKm != null
    ? Number(listing.distanceKm)
    : listing.distanceMiles
      ? Number(listing.distanceMiles) / 0.621371
      : null;
  const distanceMiles = listing.distanceMiles != null
    ? Number(listing.distanceMiles)
    : distanceKm != null
      ? Number(distanceKm) * 0.621371
      : null;

  return {
    from: fromAddress || fromCity || '',
    to: toAddress || toCity || '',
    startPoint: fromAddress,
    startCity: fromCity,
    startCountry: fromCountry,
    endPoint: toAddress,
    endCity: toCity,
    endCountry: toCountry,
    pickupFrom: listing.pickupDateFrom || null,
    pickupTo: listing.pickupDateTo || null,
    deliveryFrom: listing.deliveryDateFrom || null,
    deliveryTo: listing.deliveryDateTo || null,
    partnerPickupDate: listing.partnerPickupDate || null,
    partnerDeliveryDate: listing.partnerDeliveryDate || null,
    distanceKm,
    distanceMiles,
    distance: distanceKm,
  };
}

export function getListingTitle(listing = {}) {
  if (listing.title) return listing.title;

  const route = buildListingRoute(listing);
  const fromLabel = route.startCity || route.startPoint || '';
  const toLabel = route.endCity || route.endPoint || '';
  const routeTitle = [fromLabel, toLabel].filter(Boolean).join(' → ');
  return routeTitle || 'Untitled listing';
}

export function normalizeListing(rawListing) {
  if (!rawListing || typeof rawListing !== 'object') return rawListing;

  const listing = { ...rawListing };
  const id = listing.id || listing._id || null;
  const route = {
    ...buildListingRoute(listing),
    ...(listing.route || {}),
  };

  const normalized = {
    ...listing,
    _id: listing._id || id,
    id,
    humanId: listing.humanId || listing.reference || null,
    reference: listing.reference || listing.humanId || null,
    category: listing.category || 'other',
    title: getListingTitle({ ...listing, route }),
    fromAddress: safeText(listing.fromAddress || route.startPoint || route.from),
    fromCity: safeText(listing.fromCity || route.startCity),
    fromCountry: safeText(listing.fromCountry || route.startCountry),
    toAddress: safeText(listing.toAddress || route.endPoint || route.to),
    toCity: safeText(listing.toCity || route.endCity),
    toCountry: safeText(listing.toCountry || route.endCountry),
    distanceKm: listing.distanceKm ?? route.distanceKm ?? route.distance ?? null,
    distanceMiles: listing.distanceMiles ?? route.distanceMiles ?? null,
    pickupDateFrom: listing.pickupDateFrom || route.pickupFrom || listing.pickupDate || null,
    pickupDateTo: listing.pickupDateTo || route.pickupTo || listing.pickupDate || null,
    deliveryDateFrom: listing.deliveryDateFrom || route.deliveryFrom || null,
    deliveryDateTo: listing.deliveryDateTo || route.deliveryTo || listing.deliveryDate || null,
    partnerPickupDate: listing.partnerPickupDate || route.partnerPickupDate || null,
    partnerDeliveryDate: listing.partnerDeliveryDate || route.partnerDeliveryDate || null,
    quotes: Array.isArray(listing.quotes) ? listing.quotes : [],
    quoteCount: listing.quoteCount ?? listing.quotesCount ?? (Array.isArray(listing.quotes) ? listing.quotes.length : 0),
    allowsQuotes: listing.allowsQuotes !== undefined ? Boolean(listing.allowsQuotes) : true,
    clientPriceGross: listing.clientPriceGross != null ? Number(listing.clientPriceGross) : null,
    images: Array.isArray(listing.images) ? listing.images : [],
    items: Array.isArray(listing.items) ? listing.items : [],
    route,
  };

  return normalized;
}

export function normalizeListingList(payload) {
  if (!Array.isArray(payload)) return [];
  return payload.map(normalizeListing);
}
